/* eslint-disable @typescript-eslint/camelcase */
import { gracefulFetch } from './gracefulFetch';
import { postEvent } from './postEvent';
import { routes } from '../constants/constants';

interface Props {
  deliveryID: UUID;
}

export interface DeliveryStatusResponse {
  status:
    | 'created'
    | 'bound'
    | 'unbound'
    | 'queued'
    | 'ready'
    | 'delivered'
    | 'delivery_failed'
    | 'retrieved'
    | 'retrieval_failed';
  case_id: string;
}

export const getDeliveryStatus = async ({
  deliveryID
}: Props): Promise<DeliveryStatusResponse | undefined> => {
  let response: Response | null = null;

  if (!deliveryID) {
    if (window.location.pathname !== routes.HOME) {
      window.location.pathname = routes.HOME;
    }
    return;
  }

  try {
    response = await gracefulFetch({
      fetch: async () =>
        fetch(
          `${process.env.REACT_APP_BOX_API}/delivery/${deliveryID}/status`,
          {
            cache: 'no-store',
            method: 'GET',
            headers: {
              Accept: 'application/json'
            }
          }
        ),
      tries: 1
    });
  } catch (error) {
    postEvent({
      uuid: deliveryID,
      event: 'WEB.JUMP.ERROR',
      details: {
        info: 'getDeliveryStatus',
        error: (error as any)?.message || error,
        stack: (error as any)?.stack
      }
    });
  }

  if (response && response.ok) {
    const json = await response.json();
    return { ...json, deliveryID };
  } else {
    postEvent({
      uuid: deliveryID,
      event: 'WEB.JUMP.ERROR',
      details: {
        info: 'getDeliveryStatus',
        status: response && response.status
      }
    });
  }
};
